import {Component, OnInit} from '@angular/core';
import {AuthService} from "../../../services/auth.service";

@Component({
    selector: 'app-buy',
    templateUrl: './buy.component.html',
    styleUrls: ['./buy.component.scss'],
    providers: []
})
export class BuyComponent implements OnInit {

    constructor(public authService: AuthService) {
    }

    ngOnInit(): void {

        //

    }
}
